const setCellToDisable = (calculated, mark) => {
  if(calculated === 0) {
    mark.classList.add("not-available")
  }
}

export default setCellToDisable
